import React from "react";
import styled from "styled-components";
import { t } from "i18next";

import { WhiteLabel } from "../../../interfaces/university/whitelabel";

import Button from "../../shared/button/Button";
import Modal from "../../shared/modal/Modal";
import { Breadcrumb } from "antd";
import { breakpointSize } from "../../../theme/mediaQuerie";
import { NewWlModalContent } from "../../shared-v2/NewWlModalContent";
import { ArrowLeft } from "../../shared/Icons/ArrowLeft";
import Typography from "../../shared/typography/Typography";
import colors from "../../../theme/colors";

interface ITopBar {
  name: string;
  setName: React.Dispatch<string>;
  type: 'university' | 'event' | "video-conference" | '';
  setType: React.Dispatch<'university' | 'event' | "video-conference" | ''>;
  handleCreate: () => void;
  showModal: boolean;
  setShowModal: React.Dispatch<boolean>;
}

const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 40px;
  padding-bottom: 0;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    border-bottom: 1px solid ${props => props.theme.colors.line};
    padding: 8px 16px;
  }
`;

const isMobile = window.innerWidth <= breakpointSize.Sm;

const ListPageTopBar: React.FC<ITopBar> = ({
  handleCreate,
  name,
  setName,
  setType,
  type,
  showModal,
  setShowModal,
}) => {
  return (
    <TopBarContainer>
      {isMobile ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          {showModal ? (
            <>
              <ArrowLeft color={colors.label} size={16} onClick={() => setShowModal(false)} />
              <Typography type="paragraphXXS" >White Label</Typography>
            </>
          ) : (
            <Typography type="paragraphXXS" >{t("manage")}</Typography>
          )}
        </div>
      ) : (
        <Breadcrumb
          separator=">"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Breadcrumb.Item>{t('manage')}</Breadcrumb.Item>
          <Breadcrumb.Item href={"#"}>White Label</Breadcrumb.Item>
        </Breadcrumb>
      )}

      <Button
        typographyType={isMobile ? 'headingXXXS' : 'headingXS'}
        onClick={(isMobile && showModal) ? handleCreate : () => setShowModal(true)}
        enable={!(isMobile && showModal && name.trim() === '')}
        rounded
        backgroundActive="primaryDark"
        size="medium"
      >
        {(isMobile && showModal) ? t('dashboard.proceed') : t('dashboard.createNewWL')}
      </Button>

      <Modal
        show={showModal && !isMobile}
        handleShow={() => setShowModal(false)}
        title={''}
      >
        <NewWlModalContent handleCreate={handleCreate} name={name} setName={setName} setType={setType} type={type} />
      </Modal>
    </TopBarContainer>
  );
};

export default ListPageTopBar;
